<template>
  <div
    class="c-drawer c-drawer-close"
    :class="{ 'c-drawer-open': drawerVisible }"
  >
    <b-sidebar
      v-model="visible"
      bg-variant="white"
      right
      shadow
      no-header
      no-close-on-backdrop
    >
      <slot></slot>
      <div class="c-drawer-back">
        <b-button variant="primary" class="btn-icon" @click="handleClose">
          <feather-icon icon="ArrowLeftIcon" />
        </b-button>
        <slot name="drawerTopBtns" />
      </div>

      <div class="c-drawer-title"><slot name="drawerTopTitle" /></div>
    </b-sidebar>
  </div>
</template>

<script>
import { BSidebar, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import Store from '@/store'

export default {
  name: 'CDrwer',
  components: {
    BSidebar,
    BButton,
  },
  inject: ['getRefs'],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // 弹窗关闭前的回调
    beforeClose: {
      type: Function,
      default: (done) => {
        done()
      },
    },
  },
  data() {
    return {
      visible: false,
      drawerVisible: false,
    }
  },
  computed: {
    ...mapGetters(['pageDrawerBackBtn', 'pageDrawerVisible']),
  },
  watch: {
    value(e) {
      this.visible = e
    },
    visible(e) {
      console.log(this, 'sssss')
      document.body.scrollIntoView()
      document.body.style.overflowY = e ? 'hidden' : 'auto'
      const appContent = document.getElementsByClassName('app-content')

      if (appContent[0]) {
        appContent[0].style.overflowY = e ? 'hidden' : 'auto'
        this.getRefs()
      }

      if (e) {
        this.drawerVisible = e
      } else {
        setTimeout(() => {
          this.drawerVisible = e
        }, 300)
      }
      this.$emit('input', e)
    },
  },
  beforeDestroy() {
    setTimeout(() => {
      console.log('fff')
      document.body.style.overflowY = 'auto'
      const appContent = document.getElementsByClassName('app-content')
      console.log(appContent, 'appContentappContentappContentappContent')

      if (appContent[0]) {
        appContent[0].style.overflowY = 'auto'
        this.getRefs()
      }
    }, 300)
  },
  methods: {
    handleClose() {
      let isDone = false
      const done = () => {
        if (!isDone) {
          this.visible = false
          isDone = true
        }
      }
      this.beforeClose(done)
    },
  },
}
</script>

<style lang="scss">
.c-drawer {
  position: absolute !important;
  width: 100%;
  left: 0;
  top: 0;
  &-close {
    display: none;
    z-index: -1;
  }
  &-open {
    display: block;
    z-index: 100;
  }
  &-back,
  &-title {
    position: absolute;
    top: -50px;
    // right: 16px;
  }
  &-back {
    right: 0px;
  }
  &-title {
    right: 50%;
  }
}
.c-drawer > .b-sidebar-outer {
  position: absolute !important;
  width: 100%;
  left: 0;
  top: 0;
}
.c-drawer > .b-sidebar-outer > .b-sidebar {
  position: absolute !important;
  border-radius: 6px;
  width: 100%;
  height: calc(100vh - 118px);
  left: 0;
  top: 0;
  bottom: 0;
  transform: none;
  &-body {
    overflow-x: hidden;
  }
}
.c-drawer > .b-sidebar-outer > .b-sidebar > .b-sidebar-body {
  overflow-x: hidden;
}
</style>
